







































































































































































































































import { Component, Watch, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import cloneDeep from 'lodash/cloneDeep';
import { Sketch } from 'vue-color';
import Toggle from '@/components/Toggle.vue';
import UserMethods from '@/mixins/UserMethods.vue';

@Component({
    components: {
        Toggle,
        'sketch-picker': Sketch,
    },
})
export default class CorporationConfigsData extends Mixins(UserMethods) {
    public primaryColor: any = '';
    public secondaryColor: any = '';
    public corporationMutable: any = null;
    public showPrimaryColorPicker: boolean = false;
    public showSecondaryColorPicker: boolean = false;

    public mainLogo: any = null;
    public squireLogo: any = null;
    public mainLogoPreview: any = null;
    public squireLogoPreview: any = null;
    public expirationIntervalKey: any = null;
    public expirationIntervalValue: any = null;
    public reminderIntervalKey: any = null;
    public reminderIntervalValue: any = null;
    public reminderResponseIntervalKey: any = null;
    public reminderResponseIntervalValue: any = null;
    public responseDeadlineIntervalKey: any = null;
    public responseDeadlineIntervalValue: any = null;
    public smsOption: boolean = false;

    constructor() {
        super();
    }

    get currentCorporation() {
        return this.$store.getters['Corporations/getCurrentCorporation'];
    }

    get getSmsOption() {
        return this.smsOption;
    }

    public getIntervalsData(data: any) {
        const value = data ? data.split(' ')[0] : null;
        let key = data ? data.split(' ')[1] : null;
        key = key ? (key.charAt(key.length - 1) === 's' ? key.slice(0, -1) : key) : null;
        return  { value , key };
    }

    @Watch('primaryColor')
    public primaryColorChanged() {
        if (typeof this.primaryColor === 'object' || this.primaryColor.hasOwnProperty('hex8')) {
            this.corporationMutable.primary_color = this.primaryColor.hex8;
        }
    }

    @Watch('secondaryColor')
    public secondaryColorChanged() {
        if (typeof this.secondaryColor === 'object' || this.secondaryColor.hasOwnProperty('hex8')) {
            this.corporationMutable.secondary_color = this.secondaryColor.hex8;
        }
    }

    get corporationPrimaryLogoPreview() {
        if (this.corporationMutable.primary_logo_cdn !== null && this.mainLogoPreview === null) {
            return `background: url(${this.corporationMutable.primary_logo_cdn});`;
        }

        if (this.mainLogoPreview !== null) {
            return `background: url(${this.mainLogoPreview});`;
        }

        return `background: transparent;`;
    }

    get corporationSquireLogoPreview() {
        if (this.corporationMutable.secondary_logo_cdn !== null && this.squireLogoPreview === null) {
            return `background: url(${this.corporationMutable.secondary_logo_cdn});`;
        }

        if (this.squireLogoPreview !== null) {
            return `background: url(${this.squireLogoPreview});`;
        }

        return `background: transparent;`;
    }

    public changeImage(ref: any, type: string) {

        const element = (ref as HTMLInputElement);

        switch (type) {
            case 'logo':
                this.mainLogo = (element.files.length === 0) ? null : (element.files[0] as File);
                this.readURL(this.mainLogo, 'logo');
                break;
            case 'squire':
                this.squireLogo = (element.files.length === 0) ? null : (element.files[0] as File);
                this.readURL(this.squireLogo, 'squire');
                break;
        }

        element.type = 'text';
        element.type = 'file';
    }


    public removeImage(type: string) {
        switch (type) {
            case 'logo':
                if (this.mainLogo !== null) {
                    this.mainLogo = null;
                    this.mainLogoPreview = null;
                } else {
                    this.corporationMutable.primary_logo_cdn = null;
                }

                break;
            case 'squire':

                if (this.squireLogo !== null) {
                    this.squireLogo = null;
                    this.squireLogoPreview = null;
                } else {
                    this.corporationMutable.secondary_logo_cdn = null;
                }

                break;
        }
    }

    public readURL(file: any, previewType: any) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e: any) => {
            switch (previewType) {
                case 'logo':
                    this.mainLogoPreview = e.target.result;
                    break;
                case 'squire':
                    this.squireLogoPreview = e.target.result;
                    break;
            }
        };
    }

    public saveCorporationConfigs() {
        const data = {
            corporationId : this.corporationMutable.id,
            primaryColor : this.primaryColor ? this.primaryColor.hex8 : this.corporationMutable.primary_color,
            secondaryColor : this.secondaryColor ? this.secondaryColor.hex8 : this.corporationMutable.secondary_color,
            mainLogo : this.mainLogo,
            squireLogo : this.squireLogo,
            smsOption : this.smsOption,
            expirationInterval : this.expirationIntervalValue + ' ' + this.expirationIntervalKey,
            reminderInterval : this.reminderIntervalValue + ' ' + this.reminderIntervalKey,
            reminderResponseInterval : this.reminderResponseIntervalValue + ' ' + this.reminderResponseIntervalKey,
            responseDeadlineInterval : this.responseDeadlineIntervalValue + ' ' + this.responseDeadlineIntervalKey,
        };

        this.$store.dispatch(Actions.UPDATE_CORPORATION_CONFIGS, data);
    }

    public created() {
        this.corporationMutable = cloneDeep(this.currentCorporation);
        this.smsOption = this.currentCorporation.sms ? true : false;
        this.expirationIntervalKey = this.getIntervalsData(this.currentCorporation.expiration_interval).key;
        this.expirationIntervalValue = this.getIntervalsData(this.currentCorporation.expiration_interval).value;
        this.reminderIntervalKey = this.getIntervalsData(this.currentCorporation.reminder_interval).key;
        this.reminderIntervalValue = this.getIntervalsData(this.currentCorporation.reminder_interval).value;
        this.reminderResponseIntervalKey = this.getIntervalsData(this.currentCorporation.reminder_response_interval).key;
        this.reminderResponseIntervalValue = this.getIntervalsData(this.currentCorporation.reminder_response_interval).value;
        this.responseDeadlineIntervalKey = this.getIntervalsData(this.currentCorporation.response_deadline_interval).key;
        this.responseDeadlineIntervalValue = this.getIntervalsData(this.currentCorporation.response_deadline_interval).value;
    }
}
